import React from 'react';
import { Dialog, Divider, Stack, Box } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import DialogHeader from 'common/DialogHeader/DialogHeader';
import { useTranslation } from 'react-i18next';
import SubmitButton from 'common/SubmitButton/SubmitButton';
import { AddScheduleEmployeeModalProps, FormPayload } from './interfaces';
import schema from './AddScheduleEmployeeForm.schema';
import DateForm from './DateForm/DateForm';
import ScheduleForm from './ScheduleForm/ScheduleForm';

const validate = zodResolver(schema);

export default function AddScheduleEmployeeForm({
  employee,
  isModalOpen,
  onClose,
  onSubmit,
  defaultValues,
  isSubmitting,
}: AddScheduleEmployeeModalProps) {
  const { t } = useTranslation();
  const methods = useForm<FormPayload>({
    resolver: validate,
    mode: 'onChange',
    defaultValues,
  });

  const {
    handleSubmit,
    watch,
    formState: { errors },
  } = methods;

  const { schedule, dateFrom } = watch();

  const isDisabled = !!Object.keys(errors).length || !schedule || !dateFrom;

  return (
    <Dialog open={isModalOpen} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogHeader
        onClose={onClose}
        title={t('project_tacking.assign_work_schedule')}
      />
      <Divider />
      <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)}>
        <FormProvider {...methods}>
          <Stack direction="row" px={3}>
            <DateForm employee={employee} />
            <ScheduleForm />
          </Stack>
          <Divider />
          <Stack p={3} alignItems="flex-end">
            <SubmitButton
              noIcon
              label="label.assign"
              disabled={isDisabled}
              isLoading={isSubmitting}
            />
          </Stack>
        </FormProvider>
      </Box>
    </Dialog>
  );
}
